import { defineAsyncComponent } from 'vue';
import { AbstractModalService } from '@/core/modals/AbstractModalService';

class MobileMenuOverlayService extends AbstractModalService {
    public show() {
        return this.showModal({
            component: defineAsyncComponent(() => import(
                '@/project/layout/page-header/mobile/MobileMenu.vue')),
            componentAttrs: {
            },
            options: {
                closeOnBreakpointChange: true,
                closeOnRouteChange: false,
                showCloseButton: false,
                contentMaxHeight: false,
                disableBodyScroll: true,
                usePanelWrapper: false,
                placement: 'right'
            }
        });
    }
}

export default new MobileMenuOverlayService();
